import * as React from 'react';
import * as styles from './CountrySelect.module.scss';

export const countries = [
  {
    value: 'https://bg.flatfy.com',
    name: 'Bulgaria'
  },
  {
    value: 'https://flatfy.cz',
    name: 'Czech Republic'
  },
  {
    value: 'https://flatfy.ee',
    name: 'Estonia'
  },
  {
    value: 'https://hu.flatfy.com',
    name: 'Hungary'
  },
  {
    value: 'https://flatfy.pl',
    name: 'Poland'
  },
  {
    value: 'https://flatfy.ro',
    name: 'Romania'
  },
  {
    value: 'https://tr.flatfy.com',
    name: 'Turkey'
  },
  {
    value: 'https://flatfy.ua',
    name: 'Ukraine'
  },
];

class CountrySelect extends React.Component {
  state = {
    selected: {
      name: '',
      value: ''
    }
  };

  handleChange = event => {
    this.setState({
      selected: event.target
    }, () => {
      window.location.href = this.state.selected.value;
    });
  };

  render() {
    const { selected } = this.state;

    return (
      <select value={selected.value}
              className={styles.countrySelect}
              onChange={this.handleChange}>
        {countries.map((item, index) =>
          <option key={index}
                  value={item.value}>
            {item.name}
          </option>
        )}
      </select>
    )
  }
}

export default CountrySelect;
